import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { buildApiUrl } from "../utils/api";

function ClientEnquiry() {
    const [providers, setProviders] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [expandedRow, setExpandedRow] = useState(null);
    const itemsPerPage = 10;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(buildApiUrl("/api/getProviders"));
                const data = Array.isArray(res.data) ? res.data : [];
                setProviders(data);
                setFiltered(data);
            } catch (error) {
                console.error("Error fetching provider applications", error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const q = search.toLowerCase().trim();
        if (!q) {
            setFiltered(providers);
        } else {
            setFiltered(
                providers.filter(p =>
                    (p.name || "").toLowerCase().includes(q) ||
                    (p.email || "").toLowerCase().includes(q) ||
                    (p.firmName || "").toLowerCase().includes(q) ||
                    (p.location || "").toLowerCase().includes(q)
                )
            );
        }
        setCurrentPage(1);
    }, [search, providers]);

    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentItems = filtered.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        return new Date(dateStr).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    };

    return (
        <>
            <Helmet>
                <title>Provider Applications | CS Agent</title>
            </Helmet>

            <div className="listHead">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <h1 className="mb-0">
                        Provider Applications{" "}
                        <span className="badge bg-secondary fs-6">{filtered.length}</span>
                    </h1>
                    <input
                        type="text"
                        className="form-control"
                        style={{ minWidth: "240px", maxWidth: "320px" }}
                        placeholder="Search name, email, firm, location..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                        <thead className="custom-thead">
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Contact Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Company</th>
                                <th>Location</th>
                                <th>Total Area</th>
                                <th>Services</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((p, index) => (
                                    <React.Fragment key={p._id}>
                                        <tr>
                                            <td>{indexOfFirst + index + 1}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{formatDate(p.createdAt)}</td>
                                            <td>{p.name}</td>
                                            <td><a href={`mailto:${p.email}`}>{p.email}</a></td>
                                            <td>{p.contactNumber}</td>
                                            <td>{p.firmName}</td>
                                            <td>{p.location}</td>
                                            <td>{p.totalArea ? `${p.totalArea} sq.ft` : "-"}</td>
                                            <td style={{ maxWidth: "180px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {p.serviceProvided || "-"}
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => setExpandedRow(expandedRow === p._id ? null : p._id)}
                                                >
                                                    {expandedRow === p._id ? "Hide" : "View"}
                                                </button>
                                            </td>
                                        </tr>
                                        {expandedRow === p._id && (
                                            <tr className="table-light">
                                                <td colSpan="10">
                                                    <div className="p-3">
                                                        <div className="row g-3">
                                                            <div className="col-md-4">
                                                                <strong>Serviceable Area:</strong> {p.serviceableArea || "-"}<br />
                                                                <strong>Services Provided:</strong> {p.serviceProvided || "-"}
                                                            </div>
                                                            <div className="col-md-8">
                                                                <strong>Summary / Notes:</strong>
                                                                <p className="mt-1 mb-0" style={{ whiteSpace: "pre-wrap" }}>{p.summary || "-"}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="text-center text-muted py-4">No provider applications found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalPages > 1 && (
                    <nav className="d-flex justify-content-center">
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>&laquo;</button>
                            </li>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <li className={`page-item ${currentPage === i + 1 ? "active" : ""}`} key={i}>
                                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>&raquo;</button>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </>
    );
}

export default ClientEnquiry;
